<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="delete-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2">
        <polyline points="3 6 5 6 21 6"/>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
        <line x1="10" y1="11" x2="10" y2="17"/>
        <line x1="14" y1="11" x2="14" y2="17"/>
      </svg>
    </div>

    <h2 class="delete-title">{{ title }}</h2>
    <p class="delete-subtitle">{{ message }}</p>

    <div class="modal-actions">
      <app-button variant="secondary" [fullWidth]="true" [disabled]="isDeleting" (clicked)="onCancel()">Cancel</app-button>
      <app-button variant="danger" [fullWidth]="true" [disabled]="isDeleting" (clicked)="onConfirm()">
        {{ isDeleting ? busyLabel : confirmLabel }}
      </app-button>
    </div>
  </div>
</div>
